import React, { useEffect, useState } from 'react';
import BlogData from '../../../Assets/JsonData/BlogData.json';
import BlogList from './BlogList';

const AllBlog = () => {
    console.log(BlogData);

    const [blogs, setBlogs] = useState(BlogData)


    useEffect(() => {
        setBlogs(blogs)
    }, [blogs])



    return (
        <div>
            {blogs && blogs.map(blog => <BlogList blog={blog} key={blog.id} />)}
        </div>
    );
};

export default AllBlog;